import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTokenCheck } from '../../hooks/useTokenCheck';
import { initializeAuth } from '../../store/slices/authSlice';

const TokenCheckWrapper = ({ children }) => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);
  
  // Use the token check hook
  useTokenCheck();
  
  // Initialize auth state from localStorage on mount
  useEffect(() => {
    dispatch(initializeAuth());
  }, [dispatch]);
  
  return <>{children}</>;
};

export default TokenCheckWrapper;
